import axios from "axios";
import "../../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { getGlobalVar, setGlobalVar } from "../../config/Config";
import Header from "../../../components/Header";
import { Space, Table, Tag } from "antd";
import { render } from "@testing-library/react";

const POSPayments = () => {
  // URLS
  const auth = JSON.parse(localStorage.getItem("auth"));
  const org = auth?.org;
  const categoriesUrl = `/accountingapi/GetProductCategories/?org=${org}`;
  const productsUrl = `/accountingapi/GetProduct/?org=${org}`;
  const imgUrl = "";
  const [globalVar, setValue] = useState(getGlobalVar());

  const [products, setProducts] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [saleprice, setSalePrice] = useState("");

  const navigate = useNavigate();

  /* useEffect(() => {
    axios
      .get(`${categoriesUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        console.log(res.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${categoriesUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        console.log(res.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${productsUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        const fetchedProducts = res.data.map((product) => ({
          ...product,
          Photo: `${imgUrl}${product.Photo}`, // Prepend the base URL for images
        }));
        setProducts(fetchedProducts);
        console.log(fetchedProducts);
      });
  }, []);
 */
  const onCreateFormSubmit = (e) => {
    e.preventDefault();
    let productObj = {
      ProductName: productName,
      Price: price,
      SalesPrice: saleprice,
    };
  };

  console.log(price, saleprice, price);
  // {product.ProductCategories}
  // {product.Cost}
  // {product.SalesPrice}
  // {product.ProductType}

  const columns = [
    {
      title: "Image",
      key: "image",
      render: (_, product) => (
        <Space size="middle">
          <img src={product.Photo} alt="Product" className="" />
        </Space>
      ),
    },
    {
      title: "Tyoe",
      dataIndex: "Name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a>Edit {record.id}</a>
          <a>Delete</a>
        </Space>
      ),
    },
  ];

  // {
  //   title: 'Tags',
  //   key: 'tags',
  //   dataIndex: 'tags',
  //   render: (_, { tags }) => (
  //     <>
  //       {tags.map((tag) => {
  //         let color = tag.length > 5 ? 'geekblue' : 'green';
  //         if (tag === 'loser') {
  //           color = 'volcano';
  //         }
  //         return (
  //           <Tag color={color} key={tag}>
  //             {tag.toUpperCase()}
  //           </Tag>
  //         );
  //       })}
  //     </>
  //   ),
  // }
  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* Sidebar and Header */}
      <Header />

      {/* Main Content */}
      <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px" }}>
        <div className="row ">
          <div className=" col-12">
            <div className="row">
              <div className="col-6">
                <h1 className="text-2xl font-bold">Payments</h1>
              </div>
              <div className="col-6 "></div>
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-12 r-shadow">
            <Table columns={columns} dataSource={products} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default POSPayments;
